import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Badge, Button, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import * as app_consts from "../../utils/app_consts";
import { RETRIEVE_TENANT_AGENCY_SALES_REP_DETAILS_API } from '../../api/api_data';
import { fail_retrieve_tenant_agency_sales_rep_details, loading_retrieve_tenant_agency_sales_rep_details, reset_retrieve_tenant_agency_sales_rep_details, success_retrieve_tenant_agency_sales_rep_details } from '../../reducers/auth_tenant/retrieve_tenant_agency_sales_rep_details_Slice';
import { TENANT_RETRIEVE_SALES_REP_DETAILS_ERROR_MSG, TENANT_RETRIEVE_SALES_REP_DETAILS_SUCCESS_MSG } from '../../utils/error_success_messages';
import { formatToSentenceCase, joinWithCommas, messageToast } from '../../utils/Utils';
import { useSelector } from 'react-redux';
import { Block, BlockHead, BlockTitle, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../Component';
import CardTabs from '../../pages/components/cards/CardTabs';
import moment from 'moment';
import ViewApprovalSettingsModal from './ViewApprovalSettingsModal';

const AgencyViewSalesRepDetailsModal = ({ isOpen, closeModal, tenant_info, user_info, successFunction, data }) => {

  const [page_data, setPageData] = useState([]);
  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const dispatch = useDispatch([]);
  const [sent_data, setSentData] = useState(data);
  const [activeCardTab, setActiveCardTab] = useState("Main Info");
  const [currentOrdersPage, setCurrentOrdersPage] = useState(1);
  const [orderItemPerPage] = useState(10);
  const [view_approval_settings_modal, setViewApprovalSettingsModal] = useState(false);

  // Get current list, pagination
  const indexOfLastOrderItem = currentOrdersPage * orderItemPerPage;
  const indexOfFirstOrderItem = indexOfLastOrderItem - orderItemPerPage;
  const currentOrderItems = page_data?.orders?.slice(indexOfFirstOrderItem, indexOfLastOrderItem);

  const paginate_orders = (pageNumber) => setCurrentOrdersPage(pageNumber);

  useEffect(() => {
    if (isOpen && data)
    {
      // Dispatch
      retrieve_agency_sales_rep();
    }
    setOpen(isOpen);
  }, [isOpen, data]);

  const retrieve_agency_sales_rep = () => {
    setError("");
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_agency_sales_rep_details, success_retrieve_tenant_agency_sales_rep_details, fail_retrieve_tenant_agency_sales_rep_details, TENANT_RETRIEVE_SALES_REP_DETAILS_ERROR_MSG, TENANT_RETRIEVE_SALES_REP_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_AGENCY_SALES_REP_DETAILS_API}/${data?.sales_rep_id}/${data?.id}`));
  };
  // Listener
  const retrieve_tenant_agency_sales_rep_details_listener = useSelector((state) => state.retrieve_tenant_agency_sales_rep_details.retrieve_tenant_agency_sales_rep_details);

  useEffect(() => {
    if (retrieve_tenant_agency_sales_rep_details_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_agency_sales_rep_details_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenant_agency_sales_rep_details_listener.status === app_consts.FAIL)
        {
          setError(retrieve_tenant_agency_sales_rep_details_listener.message);
          messageToast(retrieve_tenant_agency_sales_rep_details_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_agency_sales_rep_details_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenant_agency_sales_rep_details_listener.data);
        }
        setLoading(false);
        dispatch(reset_retrieve_tenant_agency_sales_rep_details());
      }
    }
  }, [retrieve_tenant_agency_sales_rep_details_listener]);

  // Card Tabs
  const tabs = [
    {
      tabName: "Main Info"
    },
    {
      tabName: "Orders"
    },
    {
      tabName: "Approval Settings"
    }
  ];

  const open_view_approval_settings_modal = () => {
    setViewApprovalSettingsModal(true);
  };

  const close_view_approval_settings_modal = () => {
    setViewApprovalSettingsModal(false);
  };

  return (
    <>
      <Modal isOpen={open} toggle={loading ? "" : closeModal} className="modal-dialog-centered" size={"xl"}>
        <ModalHeader toggle={loading ? "" : closeModal}>Sales Rep Details</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>Retrieving Sales Rep Details...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <Row className="g-4">

                        <Block>
                          <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
                        </Block>
                        {
                          activeCardTab === "Main Info" && (
                            <>
                              <div className="card-inner bg-white">
                                <Block>
                                  <BlockHead>
                                    <BlockTitle tag="h5">Main Information</BlockTitle>
                                  </BlockHead>
                                  <div className="profile-ud-list">
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Name</span>
                                        <span className="profile-ud-value">{page_data?.name || "--"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Email Address</span>
                                        <span className="profile-ud-value">{page_data?.email_address || "--"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Mobile Number</span>
                                        <span className="profile-ud-value">{page_data?.mobile_number || "--"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">TPIN</span>
                                        <span className="profile-ud-value">{page_data?.tpin || "--"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Type</span>
                                        <span className="profile-ud-value">{page_data?.type || "--"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Allowed Brands</span>
                                        <span className="profile-ud-value">{joinWithCommas(page_data?.allowed_products) || "--"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Status</span>
                                        <span className="profile-ud-value">
                                          <span className="tb-odr-status">
                                            <Badge
                                              color={
                                                page_data?.status === app_consts.ACTIVE
                                                  ? "success"
                                                  : "warning"
                                              }
                                              className="badge-dot"
                                            >
                                              {page_data?.status ? formatToSentenceCase(page_data?.status)?.toUpperCase() : "--"}
                                            </Badge>
                                          </span></span>
                                      </div>
                                    </div>
                                  </div>
                                </Block>
                              </div>
                            </>
                          )
                        }
                        {
                          activeCardTab === "Orders" && (
                            <>
                              <div className="card-inner bg-white">
                                <Block>
                                  <BlockHead>
                                    <BlockTitle tag="h5">Orders</BlockTitle>
                                  </BlockHead>
                                  <div className="nk-tb-list is-separate is-medium mb-3">
                                    <DataTableHead className="nk-tb-item">
                                      <DataTableRow>
                                        <span className="sub-text">Order</span>
                                      </DataTableRow>
                                      <DataTableRow>
                                        <span className="sub-text">No Of Products</span>
                                      </DataTableRow>
                                      <DataTableRow size="lg">
                                        <span className="sub-text">Date Created</span>
                                      </DataTableRow>
                                      <DataTableRow size="md">
                                        <span className="sub-text">Status</span>
                                      </DataTableRow>
                                      <DataTableRow>
                                        <span className="sub-text">Action</span>
                                      </DataTableRow>
                                    </DataTableHead>
                                    {/*Head*/}
                                    {currentOrderItems.length > 0
                                      ? currentOrderItems.map((item) => (
                                        <DataTableItem key={item.id}>
                                          <DataTableRow>
                                            <div className="user-card">
                                              <div className="user-info">
                                                <span className="tb-lead">
                                                  {item?.order_name || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                                </span>
                                                <span>{item?.order_ref_number || "--"} </span>
                                              </div>
                                            </div>
                                          </DataTableRow>
                                          <DataTableRow>
                                            <div className="user-card">
                                              <div className="user-info">
                                                <span className="tb-lead">
                                                  {item?.no_of_products || "0"}
                                                </span>
                                                <span>{item?.total_value ? `${parseFloat(item?.total_value)?.toFixed(2)} ZMW` : "--"}</span>
                                              </div>
                                            </div>
                                          </DataTableRow>
                                          <DataTableRow size="md">
                                            <div className="user-info">
                                              <span className="tb-lead">{item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                              {
                                                item?.order_date_type === app_consts.BACK_DATED_LOWER && (
                                                  <>
                                                    <span className="tb-odr-date">Backdate: {item?.backdated_date ? moment(item?.backdated_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                                  </>
                                                )
                                              }
                                            </div>
                                          </DataTableRow>
                                          <DataTableRow size="md">
                                            <span className="tb-odr-status">
                                              <Badge
                                                color={
                                                  item?.status === app_consts.APPROVED_LOWER || item?.status === app_consts.DISPATCHED_LOWER
                                                    ? "success"
                                                    : "warning"
                                                }
                                                className="badge-dot"
                                              >
                                                {item?.status ? formatToSentenceCase(item?.status)?.toUpperCase() : "--"}
                                              </Badge>
                                            </span>
                                          </DataTableRow>
                                          <DataTableRow className="nk-tb-col-tools">
                                            <div className="tb-odr-btns d-none d-sm-inline">
                                              <a
                                                href={`/${tenant_info.url_prefix}/orders/${item?.order_ref_number}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                <Button color="primary" size="sm" className="btn btn-dim">
                                                  View
                                                </Button>
                                              </a>
                                            </div>
                                            <Button className="btn-pd-auto d-sm-none">
                                              <Icon name="chevron-right"></Icon>
                                            </Button>
                                          </DataTableRow>
                                        </DataTableItem>
                                      ))
                                      : null}
                                  </div>
                                  {currentOrderItems.length > 0 && (
                                    <div className="mt-3">
                                      <PaginationComponent
                                        itemPerPage={orderItemPerPage}
                                        totalItems={page_data?.orders?.length}
                                        paginate={paginate_orders}
                                        currentPage={currentOrdersPage}
                                      />
                                    </div>
                                  )}
                                </Block>
                              </div>
                            </>
                          )
                        }
                        {
                          activeCardTab === "Approval Settings" && (
                            <>
                              <Block className='my-3'>
                                <Row className="g-gs">
                                  <Col xxl="6" key={module.id}>
                                    <div className="nk-download">
                                      <div className="data">
                                        <div className="thumb">
                                          <Icon name="check-c" style={{ fontSize: "32px" }} />
                                        </div>
                                        <div className="info">
                                          <h6 className="title">
                                            <span className="name">Approval Settings</span>{" "}
                                          </h6>
                                          <div className="meta">
                                            <span className="version">
                                              <span className="text-soft"></span> <span>{page_data?.approval_settings ? "SET" : "NOT SET"}</span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="actions">
                                        <Button onClick={open_view_approval_settings_modal} color={page_data?.approval_settings ? "Active" : "primary"}>
                                          View
                                        </Button>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </Block>

                              <ViewApprovalSettingsModal closeModal={close_view_approval_settings_modal} data={page_data} isOpen={view_approval_settings_modal} tenant_info={tenant_info} user_info={user_info} successFunction={retrieve_agency_sales_rep} />
                            </>
                          )
                        }
                      </Row>
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default AgencyViewSalesRepDetailsModal;